// src/components/Filters.jsx
import React from "react";
import "../styles/Filters.css";

const priceRanges = [
  { label: "Under ₹50", min: 0, max: 50 },
  { label: "₹51 - ₹100", min: 51, max: 100 },
  { label: "₹101 - ₹200", min: 101, max: 200 },
  { label: "₹201 - ₹300", min: 201, max: 300 },
  { label: "₹301 - ₹500", min: 301, max: 500 },
  { label: "Above ₹500", min: 501, max: Infinity }
];


const Filters = ({ filters, setFilters, categories }) => {
  const toggleCategory = (category) => {
    const currentCategories = filters.categories || [];
    const updated = currentCategories.includes(category)
      ? currentCategories.filter((c) => c !== category)
      : [...currentCategories, category];
    setFilters({ ...filters, categories: updated });
  };

  const togglePriceRange = (range) => {
    const currentRanges = filters.priceRanges || [];
    const exists = currentRanges.some(
      (r) => r[0] === range.min && r[1] === range.max
    );
    const updated = exists
      ? currentRanges.filter((r) => !(r[0] === range.min && r[1] === range.max))
      : [...currentRanges, [range.min, range.max]];
    setFilters({ ...filters, priceRanges: updated });
  };

  const removeFilter = (type, value) => {
    if (type === "category") {
      const updated = filters.categories.filter((c) => c !== value);
      setFilters({ ...filters, categories: updated });
    }
    if (type === "price") {
      const updated = filters.priceRanges.filter(
        (r) => !(r[0] === value[0] && r[1] === value[1])
      );
      setFilters({ ...filters, priceRanges: updated });
    }
  };

  return (
    <div className="filters-panel">
      <div className="filters-panel__groups">
        <div className="filters-panel__group">
          <span className="filters-panel__label">Category:</span>
          <div className="filters-panel__checkbox-group">
            {categories.map((cat) => (
              <label key={cat} className="filters-panel__checkbox-label">
                <input
                  type="checkbox"
                  checked={filters.categories.includes(cat)}
                  onChange={() => toggleCategory(cat)}
                />
                {cat}
              </label>
            ))}
          </div>
        </div>

        <div className="filters-panel__group">
          <span className="filters-panel__label">Price Range:</span>
          <div className="filters-panel__checkbox-group">
            {priceRanges.map((range) => (
              <label key={range.label} className="filters-panel__checkbox-label">
                <input
                  type="checkbox"
                  checked={filters.priceRanges.some(
                    (r) => r[0] === range.min && r[1] === range.max
                  )}
                  onChange={() => togglePriceRange(range)}
                />
                {range.label}
              </label>
            ))}
          </div>
        </div>
      </div>

      {(filters.categories.length > 0 || filters.priceRanges.length > 0) && (
        <div className="filters-panel__active">
          <strong>Your Filters:</strong>
          <div className="filters-panel__active-list">
            {filters.categories.map((cat) => (
              <span key={cat} className="filters-panel__chip">
                {cat}
                <button onClick={() => removeFilter("category", cat)}>✖</button>
              </span>
            ))}
            {filters.priceRanges.map((range, idx) => (
              <span key={idx} className="filters-panel__chip">
                ₹{range[0]} - ₹{range[1]}
                <button onClick={() => removeFilter("price", range)}>✖</button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Filters;
